"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_custom_scroll_1 = __importDefault(require("react-custom-scroll"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

require("react-custom-scroll/dist/customScroll.css");

require("./SzDropDown.scss");

var SzDropDown = function SzDropDown(_a) {
  var value = _a.value,
      className = _a.className,
      image = _a.image,
      children = _a.children,
      id = _a.id;
  var dropDownClasses = classnames_1.default('sz-dropdown font-family-bold', className);
  var toggleClasses = classnames_1.default('d-flex dropdown-basic border-0 w-100 text-primary', {
    'justify-content-around align-items-center': image,
    'justify-content-center': !image
  });
  return react_1.default.createElement(react_bootstrap_1.Dropdown, {
    className: dropDownClasses
  }, react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, {
    className: toggleClasses,
    id: id
  }, image && image, react_1.default.createElement("div", null, value), react_1.default.createElement(SzIcon_1.default, {
    icon: 'arrow-down-1',
    variant: "bold",
    className: "normal ml-2 align-self-center text-right"
  })), react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, {
    className: "p-2"
  }, react_1.default.createElement(react_custom_scroll_1.default, null, react_1.default.createElement("div", {
    className: 'scrollContainer'
  }, children))));
};

SzDropDown.item = function (_a) {
  var link = _a.link,
      children = _a.children,
      onClick = _a.onClick;
  return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, {
    href: link,
    onClick: onClick,
    className: "border-bottom p-2 m-2 font-weight-bold align-items-center w-auto"
  }, children);
};

SzDropDown.propTypes = {
  value: prop_types_1.default.string,
  image: prop_types_1.default.node,
  className: prop_types_1.default.string,
  id: prop_types_1.default.string,
  children: prop_types_1.default.node
};
exports.default = SzDropDown;